export function getOrCreateSessionId() {
  let sessionId = sessionStorage.getItem("bms_session_id");
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem("bms_session_id", sessionId);
  }
  return sessionId;
}

export function isFirstQueryInSession() {
  return sessionStorage.getItem("bms_has_searched") !== "true";
}

export function markSearchPerformed() {
  sessionStorage.setItem("bms_has_searched", "true");
  console.log("Marked search as performed, hasSearched flag:", sessionStorage.getItem("bms_has_searched"));
}

export function clearSearchFlagOnLoad() {
  // Clear both the search flag and session ID to start fresh on page refresh
  sessionStorage.removeItem("bms_has_searched");
  sessionStorage.removeItem("bms_session_id");
}

